export const TOKEN_STORAGE_KEY = 'chianti_token';
export const REMENBER_PASSWORD_SWITCH_STORAGE_KEY = 'remember_password';

export const TAG_TYPE = {
  male: 'success',
  female: 'warning',
  unknown: 'info',
  init: 'info',
  completed: 'success',
  applied: 'warning',
  refunding: 'danger',
  cancelled: 'info',
  closed: 'info',
  pending: 'warning',
  shipped: '',
  received: 'success',
  draft: 'info',
  published: 'success',
  success: 'success',
  fail: 'danger',
  delay: 'warning',
  rejected: 'danger',
  making: 'warning',
  wait_confirm: 'warning',
  wait_boss_audit: 'warning',
  wait_supplier_confirm: 'warning',
  confirmed: 'warning',
  partial: 'warning',
  approved: 'success',
  wait_sales_director_audit: 'warning',
  sales_director_rejected: 'danger',
  wait_supplier_boss_confirm: 'warning',
}

export const PAGE_TYPE = {
  StaticPage: '静态页面',
  PresetPage: '内置页面'
}

export const PAGE_STATUS = ['draft', 'published']

export const CONTENT_TYPES = [
  'image',
  'video',
  'audio',
  'text',
  'xml',
  'json',
  'pdf',
  'sheet'
]

export const BANNER_PAGE_POSITIONS = [
  'event'
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link'
]

export const PURCHASE_ORDER_STATUS = {
  Received: '全部入库',
  Part_Received: '部分入库',
  Not_Received: '未入库'
}

export const FILE_ACCEPT = 'image/*,.csv,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/postscript,zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed,.gz,.tar'
export const FILE_TYPE = [
  'image',
  'csv',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/illustrator',
  'application/postscript',
  'application/zip',
  'application/x-zip-compressed',
  'application/octet-stream',
  'application/x-tar',
  'application/x-gzip'
]


export const PRODUCT_DESIGN_VIRTUAL_STATES = [
  'init', 'pending', 'making', 'completed', 'rejected', 'wait_sales_director_audit',
  'sales_director_rejected', 'receive_fabric_and_assist_confirmed', 'making_plate', 'make_plate_completed',
  'make_plate_rejected', 'cutting', 'crafting', 'craft_completed', 'cut_rejected', 'sewing',
  'sew_completed', 'sew_rejected', 'wait_audit_quantity', 'quantity_audited', 'plate_approved', 'wait_confirm_craft', 'wait_confirm_make_plate',
  'signed_sample'
]

// 用户权限相关角色组
export const USER_PERMISSIONS = {
  read_product_cost_price: ['supplier_boss'],
  update_product_cost_price: ['sales_director', 'merchandiser'],
  manage_other_product_design: ['designer', 'salesman', 'sales_director'],
  manage_other_product_design_files: ['designer', 'salesman', 'sales_director'],
  read_other_product_design_cost: ['designer', 'salesman', 'sales_director', 'merchandiser'],
  read_product_design_statistics: ['designer', 'salesman', 'sales_director', 'merchandiser'],
  read_order_cost: ['salesman', 'sales_director', 'merchandiser'],
  read_company: ['sales_director', 'merchandiser'],
  read_production_orders: ['cheif_pattern_making_officier', 'pattern_maker', 'craftsman', 'sewer', 'plate_reviewer', 'purchaser'],
}
